import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/storage-cleanup")({
  component: lazyRouteComponent(() => import("./-pages/admin.storage-cleanup")),
  head: () => ({
    meta: [
      { title: "Storage Cleanup · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
